import React from 'react'
import { useTranslation } from 'react-i18next'

import { BaseView, BaseText } from '@/components/base'
import { SkeletonListTemplate } from '../../../CurrenciesList/components/SkeletonListTemplate'
import { savingsBanner, coinPot } from '@/assets/images'

interface EmptySavingsProps {
  isLoading?: boolean
  onPress: () => void
}

export const EmptySavings: React.FC<EmptySavingsProps> = ({
  isLoading = false,
  onPress,
}) => {
  const { t } = useTranslation()

  // Mock APY - в реальном приложении будет из API
  const mockAPY = 5.5

  if (isLoading) {
    return <SkeletonListTemplate sizeList={1} />
  }

  return (
    <div
      style={{
        position: 'relative',
        height: '96px',
        borderRadius: '28px',
        overflow: 'hidden',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        padding: '16px',
        paddingLeft: '32px',
      }}
      onClick={onPress}
    >
      {/* Background Image */}
      <img
        src={savingsBanner}
        alt="Savings banner"
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          zIndex: 1,
        }}
      />

      {/* Content */}
      <div
        style={{
          position: 'relative',
          zIndex: 3,
          display: 'flex',
          flexDirection: 'column',
          gap: 7,
        }}
      >
        <BaseText
          fontSize={14}
          fontFamily="semibold"
          style={{
            color: 'white',
            lineHeight: '18px',
          }}
        >
          {t('banners:startSaving.title')}
        </BaseText>

        <BaseText
          fontSize={24}
          fontFamily="bold"
          style={{
            color: 'white',
            lineHeight: '28px',
          }}
        >
          {t('translation:earn')} {mockAPY}%
        </BaseText>
      </div>

      {/* Coin Pot Image */}
      <img
        src={coinPot}
        alt="Coin pot"
        style={{
          position: 'absolute',
          right: '4px',
          bottom: '-1px',
          height: '100px',
          width: 'auto',
          objectFit: 'contain',
          zIndex: 2,
        }}
      />
    </div>
  )
}
